export default __webpack_public_path__ + "fdf13956e54c7768b715dabe4ec05233.svg";